import { PaletteMode, PaletteOptions } from '@mui/material';
import { unityDarkTokens, unityLightTokens } from '../unityTokens';
import { GetThemeOptions } from '../theme';
import { green, grey, red, white } from './colors';

export const button = (mode: PaletteMode, opts: GetThemeOptions): PaletteOptions['button'] => {
  if (opts.panwRebrandStubYear) {
    return mode === 'light'
      ? {
          standard: {
            primary: {
              borderColor: {},
              default: unityLightTokens['--components-buttons-solid-highlight-bg-color'],
              disabled: unityLightTokens['--components-buttons-solid-highlight-bg-disabled-color'],
              hover: unityLightTokens['--components-buttons-solid-highlight-bg-hover-color'],
              text: unityLightTokens['--text-inverse-color'],
              textDisabled: unityLightTokens['--text-disabled-color'],
            },
            secondary: {
              borderColor: {},
              default: unityLightTokens['--components-buttons-solid-default-bg-color'],
              disabled: unityLightTokens['--components-buttons-solid-default-bg-disabled-color'],
              hover: unityLightTokens['--components-buttons-solid-default-bg-hover-color'],
              text: unityLightTokens['--text-bold-color'],
              textDisabled: unityLightTokens['--text-disabled-color'],
            },
            tertiary: {
              hover: unityLightTokens['--components-buttons-clear-default-bg-hover-color'],
              text: unityLightTokens['--text-bold-color'],
              disabled: 'unset',
            },
          },
          danger: {
            primary: {
              borderColor: {},
              default: unityLightTokens['--components-buttons-solid-destructive-bg-color'],
              disabled: unityLightTokens['--components-buttons-solid-destructive-bg-disabled-color'],
              hover: unityLightTokens['--components-buttons-solid-destructive-bg-hover-color'],
              text: unityLightTokens['--text-contrast-color'],
            },
            secondary: {
              borderColor: {},
              default: unityLightTokens['--components-buttons-solid-default-bg-color'],
              disabled: unityLightTokens['--components-buttons-solid-default-bg-disabled-color'],
              hover: unityLightTokens['--components-buttons-clear-destructive-bg-hover-color'],
              text: unityLightTokens['--text-destructive-color'],
              textDisabled: unityLightTokens['--text-disabled-color'],
            },
            tertiary: {
              hover: unityLightTokens['--components-buttons-clear-destructive-bg-hover-color'],
              disabled: 'unset',
            },
          },
        }
      : {
          standard: {
            primary: {
              borderColor: {},
              default: unityDarkTokens['--components-buttons-solid-highlight-bg-color'],
              disabled: unityDarkTokens['--components-buttons-solid-highlight-bg-disabled-color'],
              hover: unityDarkTokens['--components-buttons-solid-highlight-bg-hover-color'],
              text: unityDarkTokens['--text-inverse-color'],
            },
            secondary: {
              borderColor: {},
              default: unityDarkTokens['--components-buttons-solid-default-bg-color'],
              disabled: unityDarkTokens['--components-buttons-solid-default-bg-disabled-color'],
              hover: unityDarkTokens['--components-buttons-solid-default-bg-hover-color'],
              text: unityDarkTokens['--text-bold-color'],
              textDisabled: unityDarkTokens['--text-disabled-color'],
            },
            tertiary: {
              hover: unityDarkTokens['--components-buttons-clear-default-bg-hover-color'],
              text: unityDarkTokens['--text-default-color'],
              disabled: 'unset',
            },
          },
          danger: {
            primary: {
              borderColor: {},
              default: unityDarkTokens['--components-buttons-solid-destructive-bg-color'],
              disabled: unityDarkTokens['--components-buttons-solid-destructive-bg-disabled-color'],
              hover: unityDarkTokens['--components-buttons-solid-destructive-bg-hover-color'],
              text: unityDarkTokens['--text-contrast-color'],
              textDisabled: unityDarkTokens['--text-disabled-color'],
            },
            secondary: {
              borderColor: {},
              default: unityDarkTokens['--components-buttons-solid-default-bg-color'],
              disabled: unityDarkTokens['--components-buttons-solid-default-bg-disabled-color'],
              hover: unityDarkTokens['--components-buttons-clear-destructive-bg-hover-color'],
              text: unityDarkTokens['--text-destructive-color'],
              textDisabled: unityDarkTokens['--text-disabled-color'],
            },
            tertiary: {
              hover: unityDarkTokens['--components-buttons-clear-destructive-bg-hover-color'],
              disabled: 'unset',
            },
          },
        };
  }

  return mode === 'light'
    ? {
        standard: {
          primary: {
            borderColor: {},
            default: green[600],
            disabled: grey[50],
            hover: green[800],
            text: grey[50],
            textDisabled: grey[300],
          },
          secondary: {
            borderColor: {
              default: grey[300],
              disabled: grey[300],
              hover: grey[600],
            },
            default: white,
            hover: grey[50],
            text: grey[950],
            textDisabled: grey[300],
          },
          tertiary: {
            hover: grey[100],
            text: grey[500],
          },
        },
        danger: {
          primary: {
            borderColor: {},
            default: red[600],
            disabled: grey[50],
            hover: red[700],
            text: grey[50],
            textDisabled: grey[300],
          },
          secondary: {
            borderColor: {
              default: red[600],
              disabled: grey[300],
              hover: red[700],
            },
            default: white,
            hover: red[100],
            text: red[600],
            textDisabled: grey[300],
          },
          tertiary: {
            hover: red[100],
          },
        },
      }
    : {
        standard: {
          primary: {
            borderColor: {},
            default: green[500],
            disabled: grey[800],
            hover: green[300],
            text: grey[950],
            textDisabled: grey[500],
          },
          secondary: {
            borderColor: {
              default: grey[600],
              disabled: grey[600],
              hover: grey[200],
            },
            default: grey[900],
            hover: grey[800],
            text: grey[50],
            textDisabled: grey[500],
          },
          tertiary: {
            hover: 'transparent',
            text: grey[200],
          },
        },
        danger: {
          primary: {
            borderColor: {},
            default: red[500],
            disabled: grey[800],
            hover: red[100],
            text: grey[950],
            textDisabled: grey[500],
          },
          secondary: {
            borderColor: {
              default: red[600],
              disabled: grey[600],
              hover: red[500],
            },
            default: grey[900],
            hover: red[800],
            text: red[500],
            textDisabled: grey[500],
          },
          tertiary: {
            hover: red[800],
          },
        },
      };
};
